import React, { useState, useEffect, useRef } from 'react';
import { Switch, Route } from 'react-router-dom';
import { Layout } from 'antd';
import Sider from './Sider';
import Header from './Header';
import Footer from './Footer'
import routes from '../routes';
import { hasPermission } from 'libs';
import styles from './layout.module.less';
import lodash from "lodash";
import {history,setReferrerUrl} from "libs";
import Breadcrumb from "../components/Breadcrumb";


const Routes = [];

function initRoutes(routes) {
  for (let route of routes) {
    if (route.component) {
      if (!route.auth || hasPermission(route.auth)) {
        Routes.push(<Route exact key={route.path} path={route.path} component={route.component}/>)
      }
    } else if (route.child) {
      initRoutes(route.child)
    }
  }
}

initRoutes(routes)

// 404 页面
function NotFound() {
  return (
    <div className={styles.router}>
      <div className={styles.imgBlock}>
        <div className={styles.img}/>
      </div>
      <div>
        <h1 className={styles.title}>404</h1>
        <div className={styles.desc}>抱歉，你访问的页面不存在</div>
      </div>
    </div>
  )
}




export default class extends React.Component {
  constructor(props) {
    super(props);
    this.state={
      keysMap : {},
      crumb : []
    }
  }

  makeKeysMap() {
    for (let item of routes) {
      if (item.path)
        this.state.keysMap[item.path] = Object.assign({}, item)

      if (item.child&&item.child.length)
        for (let m of item.child) {
          this.state.keysMap[m.path] = Object.assign({}, m, {'pTitle': item.title,'href':item.path||''})
        }

    }
  }

  makeCrumb() {
    this.state.crumb = lodash.get(this.state.keysMap, history.location.pathname) || []
  }

  render() {
    this.makeKeysMap()
    this.makeCrumb()

    let collapsed= true
    let initPath = window.location.pathname;
    let hideToTop =  ['/login','/register'].indexOf(this.state.crumb.path) !==-1 // 当前数组内的链接   不显示返回顶部按钮+购物车按钮
    let showBrand =  ['/', '/home','/business','/login','/register','/goods','/fqa'].indexOf(this.state.crumb.path) !==-1 // 当前数组内的链接   不显示面包屑导航
    let showSlider = ['/', '/home','/business','/login','/register','/goods','/fqa','/goods/detail','/cart','/cart/submit'].indexOf(this.state.crumb.path) ===-1 //当前数组内的链接 不显示侧边栏

    document.documentElement.scrollTop = document.body.scrollTop =0;

    return (
      <Layout>
        <Header showBrand={showBrand} hideToTop={hideToTop} crumb={this.state.crumb} />
        <Layout className={showSlider?'showSlider':''}>
          <Sider showSlider={showSlider} collapsed={collapsed} initPath={initPath}/>
          <Layout.Content className={styles.mainContent}>
            <Switch>
              {Routes}
              <Route component={NotFound}/>
            </Switch>
          </Layout.Content>
        </Layout>
        <Footer/>
      </Layout>

    )
  }

}
